/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetTotalTimeOffsRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {BatchGetTotalTimeOffsResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const batchGetTotalTimeOffs = (request: BatchGetTotalTimeOffsRequest, options?: CashRequestOptions) => post<BatchGetTotalTimeOffsRequest, BatchGetTotalTimeOffsResponse>("/2.0/cash/batch-get-total-time-offs", request, {...options, rejectOnError: true })